import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { FileSelector } from '@adgate/common/components/file-selector/file-selector';
import { CustomValidators } from '@adgate/common/validators/custom-validators.validator';
import { BaseObject } from '@adgate/common/types/base-object.type';
import { ObjectDescPipe } from '@adgate/common/pipes/object-desc-pipe';
import { ComparatorService } from '@adgate/common/services/comparator-service';
import { AdGateConstants } from '@adgate/common/constants/adgate.constants';
import { AsperaFileSelector } from '@adgate/common/components/aspera-file-selector/aspera-file-selector';

@Component({
  selector: 'app-upload-dialog-component',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    MatButtonModule,
    FileSelector,
    AsperaFileSelector,
    ObjectDescPipe
  ],
  templateUrl: './upload-dialog-component.html',
  styleUrl: './upload-dialog-component.scss',
})
export class UploadDialogComponent implements OnInit
{
  private dialogRef: MatDialogRef<UploadDialogComponent> = inject(MatDialogRef<UploadDialogComponent>);
  private fb: FormBuilder = inject(FormBuilder);

  public comparatorService: ComparatorService = inject(ComparatorService);

  uploadForm!: FormGroup;
  uploadMethods: BaseObject[] = [ { id: 1, description: "HTTP" }, { id: 2, description: "Aspera Connect" } ];

  constructor()
  {
    this.uploadForm = this.fb.group({
      uploadMethod: ['', Validators.required],
      file: [{value: '', disabled: false}, [Validators.required, CustomValidators.filenameValidator()]],
      media: [null]
    });
  }

  ngOnInit(): void
  {

  }

  onCancel(): void
  {
    this.dialogRef.close(null);
  }

  onChangeUploadMethod( method: BaseObject ): void
  {
    this.uploadForm.get('file')?.setValue('');
    this.uploadForm.get('media')?.setValue([null]);
  }

  onSelectFile(selectedFiles: File[]): void
  {
    if( selectedFiles != null && selectedFiles.length > 0 ) {
      this.uploadForm.get('media')?.setValue(selectedFiles[0]);
    }
  }

  onSelectFileAspera(selectedFiles: any): void
  {
    if( selectedFiles != null && selectedFiles.dataTransfer.files.length > 0 ) {
      this.uploadForm.get('media')?.setValue(selectedFiles.dataTransfer);
    }
  }

  onSubmit(): void
  {
    if (this.uploadForm.valid) {
      let r: UploadDialogResult = {
        file: this.uploadForm.get('file')?.value,
        uploadMethod: this.uploadForm.get('uploadMethod')?.value,
        media: this.uploadForm.get('media')?.value
      }

      this.dialogRef.close(r);
    }
  }
}

export interface UploadDialogResult
{
  file: string;
  uploadMethod: BaseObject;
  media: any;
}